import { render, staticRenderFns } from "./CertsList.vue?vue&type=template&id=daf1ed9e"
import script from "./CertsList.vue?vue&type=script&lang=js"
export * from "./CertsList.vue?vue&type=script&lang=js"
import style0 from "./CertsList.vue?vue&type=style&index=0&id=daf1ed9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports